export { default as Sidebar } from './Sidebar';
export { default as LinkTab } from './LinkTab';
export { default as MedicinesTab } from './MedicinesTab';
export { default as ScorteTab } from './ScorteTab';
export { default as ScudoTab } from './ScudoTab';
export { default as SettingsTab } from './SettingsTab';
export { default as GestioneVisiteTab } from './GestioneVisiteTab';
